(function () {
  'use strict';

  var STORAGE_KEY = 'abelhinhas_attribution_v1';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'gad_campaignid', 'gad_source', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
  var lastPayload = '';
  var writeQueue = Promise.resolve();

  function safeHost(value) {
    try { return value ? new URL(value).hostname : ''; } catch (error) { return ''; }
  }

  function deviceType() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
  }

  function consentAllowsTracking() {
    if (!window.Shopify || !window.Shopify.customerPrivacy || !window.Shopify.customerPrivacy.currentVisitorConsent) return true;
    try {
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      return Boolean(consent && (consent.analytics === 'yes' || consent.marketing === 'yes'));
    } catch (error) {
      return false;
    }
  }

  function normalise(record) {
    if (!record) return null;
    var hasGoogleClickId = Boolean(record.googleClickId || record.googleBraid || record.googleAdsSource);
    var campaign = record.campaign || '';
    var content = record.content || '';
    var source = record.source || '';
    var medium = record.medium || '';
    var trafficType = 'unknown';

    if (hasGoogleClickId) {
      source = 'google';
      medium = 'cpc';
      trafficType = 'paid';
      if (/^(sag_organic|product_sync)$/i.test(campaign)) campaign = '';
      if (/^(sag_organic|product_sync)$/i.test(content)) content = '';
    } else if (source.toLowerCase() === 'google' && medium.toLowerCase() === 'cpc') {
      trafficType = 'paid';
    } else if (source.toLowerCase() === 'google' && medium.toLowerCase() === 'product_sync') {
      if (/^sag_organic$/i.test(campaign)) campaign = '';
      trafficType = 'unconfirmed_google';
    } else if (/^(cpc|ppc|paid|paid_social|display|paidsearch)$/i.test(medium)) {
      trafficType = 'paid';
    } else if (/organic/i.test(medium)) {
      trafficType = 'organic';
    } else if (source) {
      trafficType = 'referral';
    } else if (record.referrerHost) {
      trafficType = 'referral';
    } else {
      source = 'direct';
      medium = 'none';
      trafficType = 'direct';
    }

    record.source = source;
    record.medium = medium;
    record.campaign = campaign;
    record.content = content;
    record.trafficType = trafficType;
    return record;
  }

  function readStored() {
    try {
      var record = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!record || !record.capturedAt || Date.now() - record.capturedAt > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return normalise(record);
    } catch (error) {
      return null;
    }
  }

  function capture() {
    var query = new URLSearchParams(window.location.search);
    var hasCampaignData = PARAMS.some(function (key) { return query.has(key); });
    var stored = readStored();
    if (!hasCampaignData) return stored;

    var record = normalise({
      version: '2',
      capturedAt: Date.now(),
      source: query.get('utm_source') || '',
      medium: query.get('utm_medium') || '',
      campaign: query.get('utm_campaign') || '',
      content: query.get('utm_content') || '',
      term: query.get('utm_term') || '',
      campaignId: query.get('gad_campaignid') || query.get('utm_id') || '',
      googleClickId: query.get('gclid') || '',
      googleBraid: query.get('gbraid') || query.get('wbraid') || '',
      googleAdsSource: query.get('gad_source') || '',
      facebookClickId: query.get('fbclid') || '',
      rawSource: query.get('utm_source') || '',
      rawMedium: query.get('utm_medium') || '',
      rawCampaign: query.get('utm_campaign') || '',
      rawContent: query.get('utm_content') || '',
      landingPath: window.location.pathname,
      referrerHost: safeHost(document.referrer),
      device: deviceType()
    });

    if (consentAllowsTracking()) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record)); } catch (error) {}
    }
    return record;
  }

  function attributesFor(record) {
    if (!record) return null;
    return {
      ab_attribution_version: record.version,
      ab_source: record.source || '',
      ab_medium: record.medium || '',
      ab_campaign: record.campaign || '',
      ab_content: record.content || '',
      ab_term: record.term || '',
      ab_campaign_id: record.campaignId || '',
      ab_gclid: record.googleClickId || '',
      ab_google_braid: record.googleBraid || '',
      ab_fbclid: record.facebookClickId || '',
      ab_landing_path: record.landingPath || '',
      ab_referrer_host: record.referrerHost || '',
      ab_device: record.device || '',
      ab_traffic_type: record.trafficType || 'unknown',
      ab_raw_utm_source: record.rawSource || '',
      ab_raw_utm_medium: record.rawMedium || '',
      ab_raw_utm_campaign: record.rawCampaign || '',
      ab_raw_utm_content: record.rawContent || ''
    };
  }

  function saveToCart(record) {
    var attributes = attributesFor(record);
    if (!attributes || !window.fetch || !consentAllowsTracking()) return writeQueue;
    var payload = JSON.stringify({ attributes: attributes });
    if (payload === lastPayload) return writeQueue;
    lastPayload = payload;
    writeQueue = writeQueue.catch(function () {}).then(function () {
      return window.fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: payload
      }).catch(function () {});
    });
    return writeQueue;
  }

  if (!consentAllowsTracking()) return;
  var attribution = capture();
  if (!attribution) return;

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) saveToCart(attribution);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="add"], [data-add-to-cart], [data-cart-add]');
    if (button) saveToCart(attribution);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { saveToCart(attribution); }, { once: true });
  } else {
    saveToCart(attribution);
  }
}());